<template>
  <div
    class="modal fade"
    :id="clientAddressData ? 'modificardireccion' : 'nuevadireccion'"
    tabindex="-1"
    role="dialog"
    aria-labelledby="domicilio"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-body text-center modal-contenido">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="container">
            <div class="col-sm-12">
              <h4>
                <strong>{{
                  clientAddressData
                    ? 'Modificar dirección de despacho'
                    : 'Agregar nueva dirección de despacho'
                }}</strong>
              </h4>
              <br />
              <br />
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4 form-col">
                          <label class="control-label" for="lastName">Departamento *: </label>
                        </div>
                        <div class="col-sm-8">
                          <select
                            v-model="cboDepartament"
                            id="basicSelect"
                            :plain="true"
                            @change="(event) => callProvincesService(cboDepartament, false)"
                            class="form-control"
                            required
                          >
                            <option disabled value="">Seleccione Departamento</option>
                            <option
                              v-for="depa in departamentsArray"
                              :key="depa.id_departament"
                              :value="depa.id_departament"
                              >{{ depa.desc_departament }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4 form-col">
                          <label class="control-label" for="lastName">Provincia *: </label>
                        </div>
                        <div class="col-sm-8">
                          <select
                            v-model="cboProvince"
                            id="basicSelect"
                            :disabled="isProvinceFieldDisabled"
                            required
                            :plain="true"
                            @change="(event) => callDistrictService(cboProvince, false)"
                            class="form-control"
                          >
                            <option disabled value="">Seleccione Provincia</option>
                            <option
                              v-for="provincia in provincesArray"
                              :key="provincia.id_province"
                              :value="provincia.id_province"
                              >{{ provincia.desc_province }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4 form-col">
                          <label class="control-label" for="lastName">Distrito *: </label>
                        </div>
                        <div class="col-sm-8">
                          <select
                            v-model="cboDistrict"
                            id="basicSelect"
                            :disabled="isDistrictFieldDisabled"
                            required
                            :plain="true"
                            @change="(event) => enabledAddress()"
                            class="form-control"
                          >
                            <option disabled value="">Seleccione Distrito</option>
                            <option
                              v-for="distrito in districtsArray"
                              :key="distrito.id_district"
                              :value="distrito.id_district"
                              >{{ distrito.desc_district }}</option
                            >
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-4 form-col">
                          <label class="control-label" for="lastName"
                            >Dirección de despacho *:
                          </label>
                        </div>
                        <div class="col-sm-8">
                          <textarea
                            type="text"
                            class="form-control"
                            v-model="clientAddress"
                            id="emailId"
                            placeholder="Dirección"
                            minlength="10"
                            maxlength="255"
                            required
                            :disabled="isAddressFieldDisabled"
                          >
                          </textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button
              type="button"
              class="btn btn-primary"
              @click="processForm()"
              data-dismiss="modal"
            >
              {{ clientAddressData ? 'Actualizar' : 'Agregar' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr';
import { generateRefreshTokenBodyRequest, getAccessToken } from '@/helpers/localStorage.helpers';
import { config_settings } from '@/config.js';
import { UNAUTHORIZED } from '@/types/httpd.constants';
import {
  getDepartaments,
  getProvinces,
  getDistricts,
  getCompleteLocation,
} from '@/service/locations.service';
import { postNewClientAddress, putNewClientAddress } from '@/service/account.service.js';

export default {
  name: 'NewClientAddressClient',
  props: ['clientAddressData'],
  data() {
    return {
      cboDepartament: '',
      cboProvince: '',
      cboDistrict: '',
      clientAddress: '',
      departamentsArray: [],
      provincesArray: [],
      districtsArray: [],
      isProvinceFieldDisabled: true,
      isDistrictFieldDisabled: true,
      isAddressFieldDisabled: true,
    };
  },
  methods: {
    enabledAddress() {
      this.isAddressFieldDisabled = false;
    },

    processForm() {
      this.clientAddressData ? this.updateAddress() : this.addAddress();
    },

    addAddress() {
      var jsonObject = {
        id_district: { id_district: this.cboDistrict },
        address: this.clientAddress,
        state: { id_state: 1 },
      };

      postNewClientAddress(jsonObject, getAccessToken())
        .then((response) => {
          this.$parent.getClientAddressList();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.addAddress();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '/inicio' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    updateAddress() {
      var jsonObject = {
        id_address: this.clientAddressData.id_address,
        id_district: { id_district: this.cboDistrict },
        address: this.clientAddress,
      };

      putNewClientAddress(jsonObject, getAccessToken())
        .then((response) => {
          this.$parent.getClientAddressList();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.$parent
              .refreshToken()
              .then((_) => {
                this.updateAddress();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.$router.push({ path: '/inicio' });
              });
          } else {
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    callDepartamentsService() {
      getDepartaments()
        .then((response) => {
          this.departamentsArray = response.data;
        })
        .catch((error) => {
          console.log('Error at locations service');
        });
    },

    callProvincesService(departamentValue, isComponentStart) {
      getProvinces(departamentValue)
        .then((response) => {
          this.provincesArray = response.data;
          if (!isComponentStart) {
            this.cboProvince = '';
            this.cboDistrict = '';
            this.isDistrictFieldDisabled = true;
            this.clientAddress = '';
            this.isAddressFieldDisabled = true;
          }
          this.isProvinceFieldDisabled = false;
        })
        .catch((error) => {
          toastr.error(error.response.data.details, error.response.data.message, {
            iconClass: 'customer-danger',
          });
        });
    },

    callDistrictService(provinceValue, isComponentStart) {
      getDistricts(provinceValue)
        .then((response) => {
          this.districtsArray = response.data;
          if (!isComponentStart) {
            this.cboDistrict = '';
          }
          this.isDistrictFieldDisabled = false;
        })
        .catch((error) => {
          toastr.error(error.response.data.details, error.response.data.message, {
            iconClass: 'customer-danger',
          });
        });
    },

    getClientAddressDetails(idDistrict) {
      getCompleteLocation(idDistrict)
        .then((response) => {
          this.cboDepartament = response.data.departament.id_departament;
          this.callProvincesService(this.cboDepartament, true);
          this.cboProvince = response.data.province.id_province;
          this.callDistrictService(this.cboProvince, true);
          this.cboDistrict = idDistrict;
          this.isAddressFieldDisabled = false;
        })
        .catch((error) => {
          toastr.error(error.response.data.details, error.response.data.message, {
            iconClass: 'customer-danger',
          });
        });
    },

    setClientAddressData(address) {
      this.clientAddress = address.address;
      this.getClientAddressDetails(address.id_district.id_district);
    },
  },
  created() {
    this.callDepartamentsService();
    if (this.clientAddressData) {
      this.setClientAddressData(this.clientAddressData);
    }
  },
};
</script>
